import { useState } from 'react';
import MeetingsList from './MeetingsList';
import {
  add,
  eachDayOfInterval,
  endOfMonth,
  format,
  getDay,
  isEqual,
  isSameDay,
  isSameMonth,
  isToday,
  parse,
  parseISO,
  startOfToday,
  lastDayOfMonth,
  isWeekend,
} from 'date-fns';
import { srLatn } from 'date-fns/locale';
import './Calendar.css';

// u koliko bi hteli da dani krecu od nedelje krenuli bi od col-start-2 pa na dalje,
const colStartClasses = [
  'col-start-7',
  'col-start-1',
  'col-start-2',
  'col-start-3',
  'col-start-4',
  'col-start-5',
  'col-start-6',
];

const meetings = [
  {
    id: 1,
    title: 'Poslati ponudu za Oktu',
    startDatetime: '2023-03-11T13:00',
    endDatetime: '2023-03-11T14:30',
    color: '#228c73',
    user: 'Matije Vukovic',
  },
  {
    id: 2,
    title: 'Drugi zadatak',
    startDatetime: '2023-03-20T09:00',
    endDatetime: '2023-03-20T11:30',
    color: '#f67944',
    user: 'Matije Vukovic',
  },
  {
    id: 3,
    title: 'Zadatak test',
    startDatetime: '2023-03-20T17:00',
    endDatetime: '2023-03-20T18:30',
    color: '#37bbe4',
    user: 'Matije Vukovic',
  },
  {
    id: 4,
    title: 'Slanje ponude za klijenta',
    startDatetime: '2023-03-09T13:00',
    endDatetime: '2023-03-09T14:30',
    color: '#228c73',
    user: 'Matije Vukovic',
  },
  {
    id: 5,
    title: 'Neka aktivnost',
    startDatetime: '2023-02-13T14:00',
    endDatetime: '2023-02-15T14:30',
    color: '#f67944',
    user: 'Marko Markovic',
  },
  {
    id: 6,
    title: 'Sastanak sa klijentom',
    startDatetime: '2023-02-13T14:00',
    endDatetime: '2023-02-15T14:30',
    color: '#f67944',
    user: 'Marko Markovic',
  },
  {
    id: 7,
    title: 'Ponuda',
    startDatetime: '2023-02-13T14:00',
    endDatetime: '2023-02-15T14:30',
    color: '#f67944',
    user: 'Marko Markovic',
  },
  {
    id: 8,
    title: 'Slanje ponude klijentu',
    startDatetime: '2023-02-13T14:00',
    endDatetime: '2023-02-15T14:30',
    color: '#f67944',
    user: 'Marko Markovic',
  },
  {
    id: 9,
    title: 'Neka aktivnost',
    startDatetime: '2023-02-13T14:00',
    endDatetime: '2023-02-15T14:30',
    color: '#f67944',
    user: 'Marko Markovic',
  },
  {
    id: 10,
    title: 'Neka aktivnost',
    startDatetime: '2023-02-13T14:00',
    endDatetime: '2023-02-15T14:30',
    color: '#f67944',
    user: 'Petar Petrovic',
  },
  {
    id: 11,
    title: 'Neka aktivnost',
    startDatetime: '2023-02-13T14:00',
    endDatetime: '2023-02-15T14:30',
    color: '#f67944',
    user: 'Petar Petrovic',
  },
  {
    id: 12,
    title: 'Neka aktivnost',
    startDatetime: '2023-02-13T14:00',
    endDatetime: '2023-02-15T14:30',
    color: '#f67944',
    user: 'Petar Petrovic',
  },
  {
    id: 13,
    title: 'Neka aktivnost',
    startDatetime: '2023-02-13T14:00',
    endDatetime: '2023-02-15T14:30',
    color: '#f67944',
    user: 'Matije Vukovic',
  },
  {
    id: 14,
    title: 'Neka aktivnost',
    startDatetime: '2023-02-14T14:00',
    endDatetime: '2023-02-14T14:30',
    color: '#f67944',
    user: 'Petar Petrovic',
  },
  {
    id: 15,
    title: 'Neka aktivnost',
    startDatetime: '2023-02-14T14:00',
    endDatetime: '2023-02-14T14:30',
    color: '#f67944',
    user: 'Petar Petrovic',
  },
  {
    id: 16,
    title: 'Neka aktivnost',
    startDatetime: '2023-02-14T14:00',
    endDatetime: '2023-02-14T14:30',
    color: '#f67944',
    user: 'Petar Petrovic',
  },
  {
    id: 17,
    title: 'Neka aktivnost',
    startDatetime: '2023-03-16T14:00',
    endDatetime: '2023-03-16T14:30',
    color: '#f67944',
    user: 'Petar Petrovic',
  },
  {
    id: 18,
    title: 'Neka aktivnost',
    startDatetime: '2023-03-16T14:00',
    endDatetime: '2023-03-16T14:30',
    color: '#f67944',
    user: 'Matije Vukovic',
  },
  {
    id: 19,
    title: 'Neka aktivnost',
    startDatetime: '2023-03-16T14:00',
    endDatetime: '2023-03-16T14:30',
    color: '#f67944',
    user: 'Matije Vukovic',
  },
  {
    id: 20,
    title: 'Neka aktivnost',
    startDatetime: '2023-03-21T14:00',
    endDatetime: '2023-03-21T14:30',
    color: '#f67944',
    user: 'Matije Vukovic',
  },
  {
    id: 21,
    title: 'Neka aktivnost',
    startDatetime: '2023-03-22T14:00',
    endDatetime: '2023-03-22T14:30',
    color: '#f67944',
    user: 'Matije Vukovic',
  },
  {
    id: 22,
    title: 'Neka aktivnost',
    startDatetime: '2023-03-22T14:00',
    endDatetime: '2023-03-22T14:30',
    color: '#f67944',
    user: 'Matije Vukovic',
  },
  {
    id: 23,
    title: 'Neka aktivnost',
    startDatetime: '2023-03-23T14:00',
    endDatetime: '2023-03-23T14:30',
    color: '#f67944',
    user: 'Marko Markovic',
  },
];

const classNames = (...classes) => classes.filter(Boolean).join(' ');

function Scheduler() {
  const today = startOfToday();
  const [selectedDay, setSelectedDay] = useState(today);
  const [currentMonth, setCurrentMonth] = useState(format(today, 'MMM-yyyy'));
  const [animate, setAnimate] = useState(false);
  const firstDayCurrentMonth = parse(currentMonth, 'MMM-yyyy', new Date());

  // niz dana za trenuti mesec
  const days = eachDayOfInterval({
    start: firstDayCurrentMonth,
    end: endOfMonth(firstDayCurrentMonth),
  });

  // prethodni mesec
  const previousMonth = () => {
    const firstDayNextMonth = add(firstDayCurrentMonth, { months: -1 });
    setCurrentMonth(format(firstDayNextMonth, 'MMM-yyyy'));
  };
  // sledeci mesec
  const nextMonth = () => {
    const firstDayNextMonth = add(firstDayCurrentMonth, { months: 1 });
    setCurrentMonth(format(firstDayNextMonth, 'MMM-yyyy'));
  };
  // vracanje na trenutni mesec i dan
  const goToCurrentDay = () => {
    setCurrentMonth(format(today, 'MMM-yyyy'));
    setSelectedDay(today);
  };
  // niz aktivnosti za odabrani dan
  const selectedDayMeetings = meetings.filter((meeting) =>
    isSameDay(parseISO(meeting.startDatetime), selectedDay),
  );

  // za dan za koji postoji aktivnost funkcija vraca broj dodatnih aktivnosti
  // ili null ako nema vise od 1 aktivnost
  const meetingsCount = (day) => {
    const moreMeetings =
      meetings.filter((meeting) =>
        isSameDay(parseISO(meeting.startDatetime), day),
      ).length - 1;
    if (moreMeetings > 0) {
      return <p className="more-meetings">+{moreMeetings}</p>;
    }
    return null;
  };

  const addNewEvent = (day) => {
    if (day) {
      alert('Otvoriti popup za dodavanje događaja za datum');
    }
  };
  const searchEvents = () => {
    alert('Otvoriti popup za pretragu');
  };

  // funkcija za selektovanje datuma u kalendaru
  const handleSelectDay = (day) => {
    setSelectedDay(day);
    setAnimate(true);
    setTimeout(() => {
      setAnimate(false);
    }, 700);
  };

  // funkcija za prikaz dana i akvitnosti za sledeci dan u nizu
  const handleUpNext = () => {
    const lastDateOfMonth = format(lastDayOfMonth(selectedDay), 'yyyy-MM-dd');
    if (lastDateOfMonth === format(selectedDay, 'yyyy-MM-dd')) {
      nextMonth();
    }
    const nextDay = add(selectedDay, { days: 1 });
    setSelectedDay(nextDay);
    setAnimate(true);

    setTimeout(() => {
      setAnimate(false);
    }, 700);
  };

  return (
    <div className="calendar-wrapper">
      <div className="calendar">
        <div>
          <div className="calendar-header">
            <h2 className="month">
              {format(firstDayCurrentMonth, 'MMMM yyyy', {
                locale: srLatn,
              })}
            </h2>
            <button
              className="calendar-btn"
              style={{ color: '#111827', alignItems: 'center' }}
              onClick={searchEvents}
            >
              <i className="fas fa-search calendar-btn-icon" />
              Pretraži
            </button>
            <button
              className="calendar-btn"
              style={{ color: '#111827' }}
              onClick={addNewEvent}
            >
              <i className="fas fa-plus calendar-btn-icon" />
              Novi događaj
            </button>
            <button
              className="calendar-btn"
              style={{ color: '#ef4444' }}
              onClick={goToCurrentDay}
            >
              <i
                className="fas fa-calendar-day"
                style={{ marginRight: '10px', color: '#fe4444' }}
              />
              Danas
            </button>
            <button type="button" onClick={previousMonth} className="prev">
              <span className="sr-only">Previous month</span>
              <i className="fas fa-chevron-left" />
            </button>
            <button onClick={nextMonth} type="button" className="next">
              <span className="sr-only">Next month</span>
              <i className="fas fa-chevron-right" />
            </button>
          </div>
          <div className="week-days">
            <div>PON</div>
            <div>UTO</div>
            <div>SRE</div>
            <div>ČET</div>
            <div>PET</div>
            <div>SUB</div>
            <div>NED</div>
          </div>
          <div className="calendar-month">
            {days.map((day, dayIdx) => (
              <div
                key={day.toString()}
                className={classNames(
                  dayIdx === 0 && colStartClasses[getDay(day)],
                  isWeekend(day) && 'bg-weekend',
                  'day',
                )}
                onClick={() => handleSelectDay(day)} // na webu klik je na div
                onDoubleClick={() => addNewEvent(day)}
              >
                <button
                  type="button"
                  // onClick={() => setSelectedDay(day)} // na mob verziji klik je na dugme
                  className={classNames(
                    isEqual(day, selectedDay) && 'text-white',
                    !isEqual(day, selectedDay) &&
                      isToday(day) &&
                      'text-red-500',
                    !isEqual(day, selectedDay) &&
                      !isToday(day) &&
                      isSameMonth(day, firstDayCurrentMonth) &&
                      'text-gray-900',
                    !isEqual(day, selectedDay) &&
                      !isToday(day) &&
                      !isSameMonth(day, firstDayCurrentMonth) &&
                      'text-gray-400',
                    isEqual(day, selectedDay) && isToday(day) && 'bg-red-500',
                    isEqual(day, selectedDay) && !isToday(day) && 'bg-gray-900',
                    !isEqual(day, selectedDay) && 'bg-gray-200',
                    (isEqual(day, selectedDay) || isToday(day)) &&
                      'font-semibold',
                  )}
                >
                  <time dateTime={format(day, 'yyyy-MM-dd')}>
                    {format(day, 'd')}
                  </time>
                </button>
                <div className="dot-wrapper">
                  {meetings.some((meeting) =>
                    isSameDay(parseISO(meeting.startDatetime), day),
                  ) && (
                    <div>
                      <div className="dot" />
                      {meetingsCount(day)}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
        <div style={{ display: 'grid' }}>
          <MeetingsList
            selectedDayMeetings={selectedDayMeetings}
            selectedDay={selectedDay}
            animate={animate}
          />
          <div className="up-next-wrapper">
            <div className="up-next-header">
              <i style={{ marginRight: '5px' }} className="far fa-clock" />
              <p>Sledeći dan - </p>
              <time
                style={{ marginLeft: '5px' }}
                dateTime={format(add(selectedDay, { days: 1 }), 'yyyy-MM-dd')}
              >
                {format(add(selectedDay, { days: 1 }), 'MMMM dd, yyy', {
                  locale: srLatn,
                })}
              </time>
            </div>
            <button
              className="calendar-btn up-next-button"
              onClick={handleUpNext}
            >
              <i
                style={{ color: '#ef4444', marginRight: '5px' }}
                className="fas fa-arrow-down"
              />
              Pogledaj sledeći dan
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Scheduler;
